<template>
  <div id="mountNode" @click.stop>
    <div v-show="hasCompanyData" class="relation-router-btn">
      <div class="company-name">{{stockCode}}</div>
      <div>
        <el-button class="management-btn" @click="toGraphCompanyPage">企业图谱</el-button>
        <el-button class="management-btn" @click="toCompanyDetailPage">企业舆情</el-button>
      </div>
    </div>
    <div class="evidence-dialog">
      <div class="row tab-header">
        <div
          class="tab-item" 
          :class="{'tab-item-active': item === selectedOptionTab}" 
          v-for="(item, index) in tabs" 
          :key="index"
          @click="onTabChange(item)"
          >
          {{item}}
        </div>
      </div>
      <div>
        <div class="content-container" v-loading="isLoading">
          <div class="content-container-pdf">
            <div class="content-container-pdf-item" v-for="(it) in pdfTextData.pdf" :key="it.pdf_url">
              <a class="pdf-title" :href="it.pdf_url" target="_blank">{{it.pdf_name}}</a>
              <div class="pdf-img" v-for="(itx) in it.images" :key="itx">
                <el-popover
                  placement="right"
                  popper-class="pdf-img-previewer"
                  trigger="hover"
                  :visible-arrow=false
                  >
                  <div class="content-container">
                    <img class="big-img" :src="itx">            
                  </div>          
                  <img slot="reference" class="img fill" :src="itx">
                </el-popover>
              </div>
            </div>
          </div>
          <div>
            <div class="content-container-content-item" v-for="(ii) in pdfTextData.text" :key="ii.content">
              <div>{{ii.content}}</div>
              <div><a class="check-original-btn" :href="ii.url" target="_blank">查看原文</a></div>
            </div>
          </div>
          <img class="no-compant-evidence" v-if="noEvidenceData && !pdfTextData.pdf.length && !pdfTextData.text.length" src="../../assets/img/no-company-evidence.svg" alt="">
          <div class="no-compant-evidence-data" v-if="noEvidenceData && !pdfTextData.pdf.length && !pdfTextData.text.length">关系来自工商登记数据</div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import G6 from '@antv/g6';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      graph: null,
      data: null,
      stockCode: '',
      companyName: '',
      refer: null,
      selectedOptionTab: '',
      tabs: [],
      pdfTextData: {
        pdf: [],
        text: []
      },
      hasCompanyData: true,
      sourceData: '',
      targetData: '',
      noEvidenceData: false,
      isLoading: false,
      relationRouterBtn: null,
      evidenceDialog: null
    };
  },
  props: {
    relationData: {
      type: Object
    }
  },
  watch: {
    relationData(val) {
      this.data = val;
      this.graph.data(this.data);
      this.graph.render();
    }
  },
  methods: {
    closeDialog() {
      this.relationRouterBtn.style.left = '-1500px';
      this.evidenceDialog.style.left = '-1500px';
    },
    onTabChange(res) {
      this.selectedOptionTab = res;
      this.pdfTextData = {
        pdf: [],
        text: []
      };
      this.noEvidenceData = false;
      this.isLoading = true;
      questionQuery.getCompanyRefer(this.sourceData, this.targetData, this.selectedOptionTab).then(result => {
        this.isLoading = false;
        this.noEvidenceData = true;
        this.pdfTextData = result;
      });
    }, 
    toCompanyDetailPage() {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: this.companyName
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toGraphCompanyPage() {
      this.$router.push({
        name: 'atlas-page',
        query: {
          id: this.companyName,
          label: this.stockCode
        }
      });
    }
  },
  mounted() {
    this.data = this.relationData;
    this.relationRouterBtn = document.querySelector('.relation-router-btn');
    this.evidenceDialog = document.querySelector('.evidence-dialog');
    // 文本换行
    const fittingString = (str, maxWidth, fontSize) => {
      let currentWidth = 0;
      let res = str;
      const pattern = new RegExp('[\u4E00-\u9FA5]+'); // distinguish the Chinese charactors and letters
      str.split('').forEach((letter, i) => {
        if (currentWidth > maxWidth) return;
        if (pattern.test(letter)) {
          currentWidth += fontSize;
        } else {
          currentWidth += G6.Util.getLetterWidth(letter, fontSize);
        }
        if (currentWidth > maxWidth) {
          res = `${str.substr(0, i)}\n${fittingString(str.substr(i), maxWidth, fontSize)}`;
        }
      });
      return res;
    };

    this.graph = new G6.Graph({
      container: 'mountNode',
      width: 1152,
      height: 400,
      fitView: true,
      layout: {
        type: 'dagre',
        ranksep: 200,
        controlPoints: true,
        rankdir: 'LR',
        nodesepFunc: () => {
          return -12;
        }
      },
      modes: {
        default: ['drag-canvas', 'zoom-canvas']
      },
      nodeStateStyles: {
        // 鼠标 hover 上节点，即 hover 状态为 true 时的样式
        hover: {
          stroke: '#45a8cc',
          lineWidth: 2
        }
      },
      // 边不同状态下的样式集合
      edgeStateStyles: {
        hover: {
          stroke: '#45a8cc'
        }
      },
      defaultNode: {
        size: [380, 75],
        type: 'rect',
        // 节点样式配置
        style: {
          fill: '#ffffff', // 节点填充色
          stroke: '#d1d2da', // 节点描边色
          lineWidth: 1, // 节点描边粗细
          cursor: 'pointer'
        },
        // 节点上的标签文本配置
        labelCfg: {
          // 节点上的标签文本样式配置
          style: {
            fill: '#464d6c', // 节点标签文字颜色
            fontSize: 26,
            cursor: 'pointer'
          }
        }
      },
      // 边在默认状态下的样式配置（style）和其他配置
      defaultEdge: {
        type: 'polyline',
        // 边上的标签文本配置
        labelCfg: {
          autoRotate: true,
          refY: -16,
          style: {
            fill: '#747990',
            fontSize: 26,
            cursor: 'pointer'
          }
        }
      }
    });
    // eslint-disable-next-line
    this.graph.node(function (node) {
      return {
        label: fittingString(node.label, 180, 14)
      };
    });

    this.graph.data(this.data);
    this.graph.render();

    // 监听鼠标进入节点
    this.graph.on('node:mouseenter', e => {
      const nodeItem = e.item;
      // eslint-disable-next-line
      this.stockCode = e.item._cfg.model.label;
      // eslint-disable-next-line
      this.companyName = e.item._cfg.model.company_name;
      // eslint-disable-next-line
      this.hasCompanyData = e.item._cfg.model.is_company;
      // 设置目标节点的 hover 状态 为 true
      this.graph.setItemState(nodeItem, 'hover', true);
    });
    // 监听鼠标离开节点
    this.graph.on('node:mouseleave', e => {
      const nodeItem = e.item;
      // 设置目标节点的 hover 状态 false
      this.graph.setItemState(nodeItem, 'hover', false);
    });

    this.graph.on('edge:mouseenter', e => {
      const edgeItem = e.item;
      // 设置目标节点的 hover 状态 为 true
      this.graph.setItemState(edgeItem, 'hover', true);
    });

    this.graph.on('edge:click', evt => {
      evt.stopPropagation();
      // eslint-disable-next-line
      this.refer = evt.item._cfg.model.refer;
      // eslint-disable-next-line
      this.sourceData = evt.item._cfg.model.source;
      // eslint-disable-next-line
      this.targetData = evt.item._cfg.model.target;
      this.tabs = Object.keys(this.refer);
      this.selectedOptionTab = this.tabs[0];
      this.pdfTextData = {
        pdf: [],
        text: []
      };
      this.noEvidenceData = false;
      this.isLoading = true;
      questionQuery.getCompanyRefer(this.sourceData, this.targetData, this.selectedOptionTab).then(res => {
        this.isLoading = false;
        this.noEvidenceData = true;
        this.pdfTextData = res;
      });
      if (evt.x > 920) {
        this.evidenceDialog.style.left = '760px';
      } else {
        this.evidenceDialog.style.left = `${evt.x - 420}px`;
      }
      this.evidenceDialog.style.top = '0px';
    });

    this.graph.on('edge:mouseleave', e => {
      const edgeItem = e.item;
      // 设置目标节点的 hover 状态 false
      this.graph.setItemState(edgeItem, 'hover', false);
    });

    this.graph.on('node:click', evt => {
      evt.stopPropagation();
      // eslint-disable-next-line
      if (evt.item._cfg.model.is_company) {
        this.hasCompanyData = true;
        if (evt.x < 500) {
          this.relationRouterBtn.style.left = '100px';
        } else if (evt.x > 2000) {
          this.relationRouterBtn.style.left = '900px';
        } else {
          this.relationRouterBtn.style.left = `${evt.x - 800}px`;
        } 
        if (evt.y > 600) {
          this.relationRouterBtn.style.top = '300px';
        } else if (evt.y <= 300) {
          this.relationRouterBtn.style.top = `${evt.y - 50}px`;
        } else {
          this.relationRouterBtn.style.top = `${evt.y - 300}px`;
        }
      } else {
        this.hasCompanyData = false;
      }
    });

    this.graph.on('click', () => {
      this.relationRouterBtn.style.left = '-1500px';
      this.evidenceDialog.style.left = '-1500px';
    });
  }
};
</script>

<style lang="scss" scoped>
#mountNode {
  position: relative;
  background-color: #ffffff;
}
.relation-router-btn {
  position: absolute;
  left: -1500px;
  padding: 16px;
  width: 240px;
  min-height: 88px;
  border-radius: 2px;
  box-shadow: 0px 8px 20px 0px rgba(0, 22, 144, 0.14);
  background-color: #ffffff;
  .company-name {
    margin-bottom: 10px;
    color: #45a8cc;
    font-size: 14px;
  }
  .management-btn {
    height: 26px;
    width: 72px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #ffffff;
    background-color: #45a8cc;
    &:hover {
      color: #ffffff;
      background-color: #45a8cc;
    }
    &:focus {
      color: #ffffff;
      background-color: #45a8cc;
    }
    &:active {
      color: #ffffff;
      background-color: #45a8cc;
    }
  }
}
.evidence-dialog {
  position: absolute;
  left: -1500px;
  width: 400px;
  height: 420px;
  background-color: #ffffff;
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  .tab-header {
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    width: 100%;
    box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    .tab-item {
      margin-right: 16px;
      margin-bottom: 6px;
      color: #747990;
      font-size: 14px;
      cursor: pointer;
    }
    .tab-item-active {
      position: relative;
      color: #171f46;
    }
    .tab-item-active::after {
      content: "";
      position: absolute;
      top: 33px;
      left: 50%;
      transform: translateX(-50%);
      width: 14px;
      height: 3px;
      background-color: #171f46;
    }
  }
  .content-container {
    position: relative;
    padding: 0 16px;
    height: 366px;
    overflow: auto;
    .no-compant-evidence {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 123px;
    }
    .no-compant-evidence-data {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 196px;
      color: #9ea1b4;
      font-size: 14px;
    }
    .content-container-pdf {
      .content-container-pdf-item {
        padding: 10px 0;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
        .pdf-title {
          margin-left: 10px;
          color: rgba(69, 168, 204, 1);
          font-weight: 600;
          font-size: 12px;
        }
        .pdf-img {
          .img {
            max-width: 364px;
          }
        }
      }
    }
    .content-container-content-item {
      padding: 10px 0;
      box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      color: #747990;
      font-size: 14px;
      .check-original-btn {
        color: #45a8cc;
        font-size: 12px;
        text-decoration: none;
      }
    }
  }
}
</style>
<style lang="scss">
  .el-popover.pdf-img-previewer {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    .content-container {
      .big-img {
        display: block;
        margin: 0 auto;
        max-width: 700px !important;
        max-height: 399px !important;
      }
    }
  }
</style>
